import { getGenericEndpoint } from './get.api';
import type { GetFriendsAndFamilyResponse } from './types';

export const getFriendsAndFamily = async (lang?: string) => {
	return await getGenericEndpoint<GetFriendsAndFamilyResponse>(
		'friends-and-family',
		lang
	);
};

export const getFriendsAndFamilyFind = async (lang?: string) => {
	return await getGenericEndpoint<GetFriendsAndFamilyResponse>(
		'friends-and-family/find',
		lang
	);
};

export const getFriendsAndFamilyNew = async (lang?: string) => {
	return await getGenericEndpoint<GetFriendsAndFamilyResponse>(
		'friends-and-family/new',
		lang
	);
};
